module.exports = __webpack_public_path__ + "img/muyu_des_2.ce177580.jpg";